// frontend/src/utils/RoleEnum.js

const RoleEnum = Object.freeze({
  ADMIN: 1,
  LEARNER: 2,
  // Add more roles as needed
});
export default RoleEnum;
